import { ReactNode } from 'react'
import { Stack, TableCell, TableRow } from '@mui/material'

interface StoreyControlsTableRowProps {
  icon?: ReactNode
  text?: ReactNode
  actionsColumn1?: ReactNode
  columnsCombined?: ReactNode
  visibilityColumn1?: ReactNode
  visibilityColumn2?: ReactNode
  visibilityColumn3?: ReactNode
  additionalColumn1?: ReactNode
  withTopDivider?: boolean
  /** Compact mode: hide the secondary type columns (visibilityColumn2 / visibilityColumn3). */
  compact?: boolean
}

const baseCellSx = {
  px: 0.5,
  py: 0.125,
  verticalAlign: 'middle',
}

const StoreyControlsTableRow = ({
  icon,
  text,
  actionsColumn1,
  columnsCombined,
  visibilityColumn1,
  visibilityColumn2,
  visibilityColumn3,
  additionalColumn1,
  withTopDivider = false,
  compact = false,
}: StoreyControlsTableRowProps) => (
  <TableRow
    sx={{
      borderTop: withTopDivider ? theme => `1px solid ${theme.palette.divider}` : 'none',
    }}
  >
    <TableCell sx={baseCellSx}>
      <Stack direction="row" alignItems="center" justifyContent="center">
        {icon}
      </Stack>
    </TableCell>
    <TableCell sx={baseCellSx}>
      <Stack direction="row" alignItems="center">
        {text}
      </Stack>
    </TableCell>
    <TableCell sx={{ ...baseCellSx, minWidth: 75 }}>{actionsColumn1}</TableCell>
    {columnsCombined ? (
      <TableCell colSpan={compact ? 2 : 4} sx={baseCellSx}>
        <Stack direction="row" spacing={0.5} alignItems="center">
          {columnsCombined}
        </Stack>
      </TableCell>
    ) : (
      <>
        <TableCell sx={{ ...baseCellSx, width: '1%', whiteSpace: 'nowrap' }}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            {visibilityColumn1}
          </Stack>
        </TableCell>
        {!compact && (
          <TableCell
            sx={{
              ...baseCellSx,
              width: '1%',
              whiteSpace: 'nowrap',
              borderLeft: theme => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Stack direction="row" spacing={0.5} alignItems="center">
              {visibilityColumn2}
            </Stack>
          </TableCell>
        )}
        {!compact && (
          <TableCell
            sx={{
              ...baseCellSx,
              width: '1%',
              whiteSpace: 'nowrap',
              borderLeft: theme => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Stack direction="row" spacing={0.5} alignItems="center">
              {visibilityColumn3}
            </Stack>
          </TableCell>
        )}
        <TableCell sx={baseCellSx}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            {additionalColumn1}
          </Stack>
        </TableCell>
      </>
    )}
  </TableRow>
)

export default StoreyControlsTableRow
